
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Meta from 'components/Meta';
import TextPage from 'components/TextPage';
export default function Page() {
    const name = 'Creation of a prototype of a virtual longevity assistant based on artificial intelligence';
    const excerpt = 'Creation of a prototype of a virtual longevity assistant based on artificial intelligence';
    const content = '<img src="/es-pr.png" /><p>UAB "Vital habits" is implementing a project during which a prototype of a virtual longevity assistant based on artificial intelligence will be created. This will be an innovative product that will connect the totality of actions (habits) that influence human health with the informational and psychological - manipulative power of artificial intelligence into a real-time feedback loop in order to strengthen habits that have a positive impact on a person`s health and suppress habits and actions that have a negative impact on health.</p><p>The project is partially financed by the funds of the "Next Generation Lithuania" plan.</p><p>Project title: "Creation of a prototype of a virtual longevity assistant based on artificial intelligence";</p><p>Project implementer: UAB "Vital habits";</p><p>Project implementation period: 2025-02 / 2026-02;</p><p>Total project budget: EUR 107,500, of which the part financed by the plan "Next Generation Lithuania" amounts to EUR 86,000.</p>';
    return (<TextPage html={content}>
            <Meta title={name} description={excerpt}/>
            <h1 className="h2">{name}</h1>
        </TextPage>);
}

    async function __Next_Translate__getStaticProps__19639cc49c4__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/es-projects',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19639cc49c4__ as getStaticProps }
  